import './SilverRateDropdown.css';

import React, {
  useEffect,
  useState,
} from 'react';

import axios from 'axios';

const SilverRateDropdownComponent = () => {
  const [prices, setPrices] = useState({ gold: null, silver: null })
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    const fetchPrices = async () => {
      try {
        const localResponse = await axios.get(
          'https://app.dhanapaljewellery.com/api/v1/rates',
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )
        const rates = localResponse.data // Array of RateData objects

        if (rates && rates.length > 0) {
          // Sort by createdAt descending and take the latest
          const latestRate = rates.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          )[0]
          setPrices({
            gold: latestRate.goldRate,
            silver: latestRate.silverRate,
          })
          setLoading(false)
        } else {
          setError('No rates available in local database')
          setLoading(false)
        }
      } catch (localErr) {
        console.error('Failed to fetch local rates:', localErr)
   
        setLoading(false)
      
      try {
        // Step 1: Try primary API
        const response = await axios.get(
          'https://jerwishtech.site/v1/api/account/todayrate'
        )
        setPrices({
          gold: response.data.Rate, // Adjust based on API response
          silver: response.data.SILVERRATE, // Adjust based on API response
        })
        setLoading(false)
      } catch (err) {
        console.warn(
          'Primary API failed, falling back to local rates:',
          err.message
        )
        // Step 2: Fallback to local getAllRates API
        
      }
    }
  }
    fetchPrices()
  }, []) // Runs once on mount

  if (loading) {
    return <div>Loading...</div>
  }

  if (error) {
    return <div>{error}</div>
  }

  return (
    <div className="silver-dropdown-container">
      <div className="silver-rate-label"></div>
      <div className="silver-dropdown">
        <button
          className="silver-dropdown-toggle dropdown-toggle"
          onClick={() => setIsOpen(!isOpen)}
          style={{
            background: 'linear-gradient(135deg, #C0C0C0, #A9A9A9)',
            transition: '0.3s',
          }}
        >
          <span>Silver 1G: ₹{prices.silver}</span>
          {/* <span className={`dropdown-arrow ${isOpen ? "open" : ""}`}>▼</span> */}
        </button>
        {isOpen && (
          <ul className="silver-dropdown-menu">
            <li>Gold Rate: ₹{prices.gold}</li> {/* Display gold rate */}
            <li>Silver 24K: ₹{prices.silver}</li> {/* Example adjustment */}
            <li>Silver 22K: ₹000</li>
            <li>Silver 18K: ₹000</li>
          </ul>
        )}
      </div>
    </div>
  )
}

export default SilverRateDropdownComponent
